import React from 'react';
import classNames from 'classnames';

import Icon, { IconNames } from './presenter';

import { iconDefaultProps, iconPropTypes } from './iconPropTypes';


const CaretLeftIcon = ({ className, size, ...rest }) => (
  <Icon
    className={classNames({
      'j-l-caret-icon': true,
      [className]: className,
    })}
    name={IconNames.CARET_LEFT}
    size={size}
    {...rest}
  />
);

CaretLeftIcon.propTypes = {
  ...iconPropTypes,
};

CaretLeftIcon.defaultProps = {
  ...iconDefaultProps,
};


export default CaretLeftIcon;
